(function () {
  'use strict';

  var formTimers = new WeakMap();

  function isHebrew() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('he') === 0;
  }

  function text(key, value) {
    var he = {
      summary: 'לא ניתן לשלוח עדיין. יש לתקן את השדות הבאים:',
      required: 'נא למלא את השדה „' + value + '”.',
      choose: 'נא לבחור אפשרות עבור „' + value + '”.',
      email: 'נא להזין כתובת דוא״ל תקינה.',
      phone: 'נא להזין מספר טלפון תקין.',
      number: 'נא להזין מספר תקין בשדה „' + value + '”.',
      minimum: 'הערך המינימלי בשדה „' + value + '” הוא ',
      invalid: 'נא לבדוק את השדה „' + value + '”.'
    };
    var en = {
      summary: 'The form cannot be submitted yet. Please correct:',
      required: 'Please complete “' + value + '”.',
      choose: 'Please select an option for “' + value + '”.',
      email: 'Please enter a valid email address.',
      phone: 'Please enter a valid phone number.',
      number: 'Please enter a valid number for “' + value + '”.',
      minimum: 'The minimum value for “' + value + '” is ',
      invalid: 'Please check “' + value + '”.'
    };
    return (isHebrew() ? he : en)[key];
  }

  function cleanLabel(value) {
    return (value || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/:$/, '');
  }

  function fieldLabel(field) {
    var label;
    if (field.id) label = document.querySelector('label[for="' + CSS.escape(field.id) + '"]');
    if (!label) label = field.closest('label');
    if (label) {
      var clone = label.cloneNode(true);
      clone.querySelectorAll('input, select, textarea, .damder-field-error').forEach(function (node) { node.remove(); });
      var labelText = cleanLabel(clone.textContent);
      if (labelText) return labelText;
    }

    var fieldset = field.closest('fieldset');
    var legend = fieldset && fieldset.querySelector('legend');
    if (legend) return cleanLabel(legend.textContent);

    return cleanLabel(field.getAttribute('aria-label') || field.getAttribute('placeholder') || field.name || (isHebrew() ? 'שדה זה' : 'this field'));
  }

  function messageFor(field) {
    var label = fieldLabel(field);
    var validity = field.validity;

    if (validity.customError && field.validationMessage) return field.validationMessage;
    if (validity.valueMissing) {
      if (field.type === 'radio' || field.type === 'checkbox') return text('choose', label);
      return text('required', label);
    }
    if (validity.typeMismatch && field.type === 'email') return text('email', label);
    if (validity.patternMismatch && field.type === 'tel') return text('phone', label);
    if (validity.badInput && field.type === 'number') return text('number', label);
    if (validity.rangeUnderflow) return text('minimum', label) + field.min + '.';
    return text('invalid', label);
  }

  function errorAnchor(field) {
    if (field.type === 'radio' || field.type === 'checkbox') {
      return field.closest('fieldset') || field.closest('[role="group"]') || field.parentElement;
    }
    return field;
  }

  function errorId(field) {
    if (!field.dataset.damderValidationId) {
      field.dataset.damderValidationId = 'damder-error-' + Math.random().toString(36).slice(2, 10);
    }
    return field.dataset.damderValidationId;
  }

  function clearFieldError(field) {
    var id = field.dataset.damderValidationId;
    if (id) {
      var error = document.getElementById(id);
      if (error) error.remove();
    }
    field.removeAttribute('aria-invalid');
    var describedBy = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (id) describedBy = describedBy.filter(function (value) { return value !== id; });
    if (describedBy.length) field.setAttribute('aria-describedby', describedBy.join(' '));
    else field.removeAttribute('aria-describedby');
  }

  function showFieldError(field) {
    clearFieldError(field);
    var id = errorId(field);
    var error = document.createElement('span');
    error.id = id;
    error.className = 'damder-field-error';
    error.setAttribute('role', 'alert');
    error.textContent = messageFor(field);
    errorAnchor(field).insertAdjacentElement('afterend', error);
    field.setAttribute('aria-invalid', 'true');
    var describedBy = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (describedBy.indexOf(id) === -1) describedBy.push(id);
    field.setAttribute('aria-describedby', describedBy.join(' '));
  }

  function invalidFields(form) {
    var seenGroups = {};
    return Array.prototype.filter.call(form.elements, function (field) {
      if (!field || field.disabled || !field.willValidate || field.validity.valid) return false;
      if ((field.type === 'radio' || field.type === 'checkbox') && field.name) {
        if (seenGroups[field.name]) return false;
        seenGroups[field.name] = true;
      }
      return true;
    });
  }

  function clearSummary(form) {
    var summary = form.querySelector('.damder-form-errors[data-damder-generated="true"]');
    if (summary) summary.remove();
  }

  function showSummary(form, fields) {
    clearSummary(form);
    if (!fields.length) return;

    var summary = document.createElement('div');
    summary.className = 'damder-form-errors';
    summary.dataset.damderGenerated = 'true';
    summary.setAttribute('role', 'alert');
    summary.setAttribute('tabindex', '-1');

    var title = document.createElement('p');
    title.className = 'damder-form-errors__title';
    title.textContent = text('summary', '');
    summary.appendChild(title);

    var list = document.createElement('ul');
    fields.forEach(function (field) {
      var item = document.createElement('li');
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = messageFor(field);
      button.addEventListener('click', function () { field.focus(); });
      item.appendChild(button);
      list.appendChild(item);
    });
    summary.appendChild(list);

    var firstContent = Array.prototype.find.call(form.children, function (child) {
      return child.type !== 'hidden' && child.tagName !== 'STYLE' && child.tagName !== 'SCRIPT';
    });
    form.insertBefore(summary, firstContent || form.firstChild);
    summary.focus();
  }

  function refreshForm(form) {
    var fields = invalidFields(form);
    fields.forEach(showFieldError);
    showSummary(form, fields);
  }

  document.addEventListener('invalid', function (event) {
    var field = event.target;
    var form = field && field.form;
    if (!form || form.noValidate) return;
    event.preventDefault();
    form.dataset.damderValidationAttempted = 'true';
    showFieldError(field);
    window.clearTimeout(formTimers.get(form));
    formTimers.set(form, window.setTimeout(function () { refreshForm(form); }, 0));
  }, true);

  function handleFieldUpdate(event) {
    var field = event.target;
    var form = field && field.form;
    if (!form) return;
    if (field.validity.valid) clearFieldError(field);
    if (form.dataset.damderValidationAttempted === 'true') {
      window.clearTimeout(formTimers.get(form));
      formTimers.set(form, window.setTimeout(function () { refreshForm(form); }, 80));
    }
  }

  document.addEventListener('input', handleFieldUpdate, true);
  document.addEventListener('change', handleFieldUpdate, true);
  document.addEventListener('submit', function (event) {
    clearSummary(event.target);
  }, true);
}());
